import { NO_IMAGE_SRC_PATH } from "@/constants/image";
import { Loader } from "lucide-react";
import Image from "next/image";
import { useEffect, useState } from "react";

interface Props {
  src?: string;
}

export default function ImageInput({ src }: Props) {
  const [imageSrc, setImageSrc] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setImageSrc(src || NO_IMAGE_SRC_PATH);
    setLoading(true);
  }, [src]);

  return (
    <div className="relative flex w-full flex-1 overflow-hidden rounded border border-gray-300">
      <Image
        crossOrigin="anonymous"
        className="h-auto w-full cursor-pointer object-contain"
        src={imageSrc || "/images/default_image.png"}
        alt=""
        width={500}
        height={500}
        onError={() => setImageSrc(NO_IMAGE_SRC_PATH)}
        onLoad={() => setLoading(false)}
      />
      {loading && (
        <div className="absolute flex h-full w-full items-center justify-center bg-gray-300 opacity-50">
          <Loader className="animate-spin" />
        </div>
      )}
    </div>
  );
}
